/* Copyright (c) 2016-2024 Planticle Pty Ltd */
"use strict";

var programs = [
	require("./programs/abc.js").default,
	require("./programs/birdata.js").default,
	require("./programs/biby.js").default,
	require("./programs/bof.js").default,
	require("./programs/bittern.js").default,
	require("./programs/bnb.js").default,
	require("./programs/bwb.js").default,
	require("./programs/cockywatch.js").default,
	require("./programs/cnb.js").default,

	require("./programs/egnb.js").default,

	require("./programs/obp.js").default,
	require("./programs/powl.js").default,
	require("./programs/rgh.js").default,
	require("./programs/reho.js").default,
	require("./programs/s2020.js").default,
	require("./programs/segbc.js").default,
	require("./programs/wa-cockies.js").default,
	require("./programs/sop.js").default,
	require("./programs/swp.js").default,
	require("./programs/wetland.js").default
];


var promise;
function load() {
	if(!promise) {
		promise = Promise.all(
			programs.map(p => p.load ? p.load() : Promise.resolve(true))
		).then(() => programs);
	}
	return promise;
}

programs.find = function(code) {
	return Array.prototype.find.call(this, program => program.code == code);
};

export default load;
